// Map a default-page name (as stored in Mongo — always Dutch, matches
// deps.DEFAULT_PAGES) to its translation key. Custom (user-added) pages
// are not in this map so they display their raw name in every language.
const DEFAULT_PAGE_KEY = {
  "Introductie": "pages.introduction",
  "Merkstrategie": "pages.brand_strategy",
  "Tone of voice": "pages.tone_of_voice",
  "Logo": "pages.logo",
  "Kleuren": "pages.colors",
  "Typografie": "pages.typography",
  "Art direction": "pages.art_direction",
  "Merksysteem": "pages.brand_system",
  "Concept middelen": "pages.applications",
};

/**
 * Returns the localized label for a page.
 * - Default pages → translated via i18n (`page_name` matches the Dutch label in Mongo).
 * - Custom pages (is_default === false) OR unknown names → raw name, so a
 *   user who renamed "Logo" to "Merkmark" keeps seeing "Merkmark" everywhere.
 */
export function pageLabel(page, t) {
  if (!page) return "";
  if (page.is_default === false) return page.name || "";
  const key = DEFAULT_PAGE_KEY[page.name];
  if (!key) return page.name || "";
  const translated = t(key);
  // t() returns the key verbatim when missing — fall back to the stored name.
  return translated === key ? (page.name || "") : translated;
}
